import _ from 'lodash'
import ResizeMixin from './ResizeMixin'
import Dragging from '../../core/mixins/dragging/KDragging'

export default {
  name: 'KLayout',
  mixins: [Dragging, ResizeMixin],
  provide() {
    return {
      context: this,
    }
  },
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasLayoutComponentDragging: false,
    }
  },
  computed: {
    shouldVertical() {
      if (this.vertical) {
        return true
      }

      const hasHeaderOrFooter = _.some(this.$slots.default, vnode => {
        return vnode.componentOptions && ['k-header', 'k-footer'].indexOf(vnode.componentOptions.tag) !== -1
      })

      return hasHeaderOrFooter
    },
  },
  watch: {},
  methods: {},
  render() {
    const style = _.assign({}, this.resizeStyle)

    const css = {
      'km-layout': true,
      'km-layout--vertical': this.shouldVertical,
      'km-layout--dragging': this.hasLayoutComponentDragging,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <section {...data}>
        {this.$slots.default}
      </section>
    )
  },
}
